module.exports = __webpack_public_path__ + "static/media/dau.25194fd1.svg";